import useSWR from "swr";
import type { SwrReturnType } from "~/models/Api";
import type { Notification } from "~/models/Notification";

const paths = {
	index: "/vendors/vendor_notifications"
};

type TIndex = () => SwrReturnType<Notification[]>;
type ReturnType = {
	index: TIndex;
};

export const useVendorNotifications = (): ReturnType => {
	const index: TIndex = () => {
		// eslint-disable-next-line react-hooks/rules-of-hooks
		const { data, mutate, error } = useSWR<Notification[]>(paths.index);
		return {
			data: data ?? null,
			error,
			isLoading: !data && !error,
			mutate: mutate ?? null
		};
	};
	return { index };
};
